import { DictionaryItem, fillArr, getByOrder } from '@hglobal/common';

import { Country, Currencies, Currency, Skin, WalletsSkinCollection, WalletType } from '@pp/core/entities';

// ---------- Countries ---------
export function getCountriesMock(): Country[] {
  return [
    { id: 1, countryCode: 'DU', countryName: 'Dutch' },
    { id: 2, countryCode: 'CH', countryName: 'China' },
  ];
}

// ---------- Currencies ---------

type CurrencyType = 'fiat' | 'crypto' | 'all';

export const currencyCodes = ['USD', 'EUR'];
export const currencyUnicodes = ['$', '€'];
export const coinCodes = ['USDT', 'BTC', 'ETH', 'TRX'];
export const coinUnicodes = ['₮', '₿', 'Ξ', '☉'];
export const allCurrencyCodes = [...currencyCodes, ...coinCodes];
export const allCurrencyUnicodes = [...currencyUnicodes, ...coinUnicodes];
export const networks = ['ERC-20', 'TRC-20'];

export function getCurrencyMock(i: number, type: CurrencyType = 'all'): Currency {
  let codes: string[];
  let unicodes: string[];

  if (type === 'fiat') {
    codes = currencyCodes;
    unicodes = currencyUnicodes;
  } else if (type === 'crypto') {
    codes = coinCodes;
    unicodes = coinUnicodes;
  } else {
    codes = allCurrencyCodes;
    unicodes = allCurrencyUnicodes;
  }

  const code = getByOrder(i, codes);

  return {
    id: i,
    name: code,
    code,
    network: code === 'USDT' ? getByOrder(i, networks) : null,
    image: {
      id: i,
      url: `/assets/images/mocks/currencies/${code}.svg`,
      name: code,
    },
    unicode: getByOrder(i, unicodes),
  };
}

export function getFiatsMock(): Currency[] {
  return fillArr(currencyCodes.length, i => getCurrencyMock(i, 'fiat'));
}

export function getCoinsMock(): Currency[] {
  return fillArr(coinCodes.length, i => getCurrencyMock(i, 'crypto'));
}

export function getAllCurrenciesMock(): Currency[] {
  return fillArr(allCurrencyCodes.length, i => getCurrencyMock(i));
}

export function getCurrenciesMock(): Currencies {
  return {
    crypto: getCoinsMock(),
    fiat: getFiatsMock(),
  };
}

// ---------- Roles ---------

export function getRolesMock(): DictionaryItem<string>[] {
  return [
    { id: 'Administrator', name: 'Administrator' },
    { id: 'Buyer', name: 'Buyer' },
    { id: 'Supervisor', name: 'Supervisor' },
  ];
}

// ---------- Skins ---------

export function getCardSkinsMock(count: number): Skin[] {
  return fillArr(count, i => getCardSkinMock(i));
}

export function getCardSkinMock(i: number): Skin {
  return {
    id: i - 1,
    name: `skin ${i - 1}`,
    url: `/assets/images/wallets/card-${i}.png`,
  };
}

export function getWalletSkinMock(i: number, type: WalletType): Skin {
  return {
    id: getWalletSkinIdMock(i, type),
    name: `skin ${getWalletSkinIdMock(i, type)}`,
    url: `/assets/images/wallets/${type}.png`,
  };
}

export const getWalletSkinsByTypeMock = (type: WalletType, count = 3): Skin[] => fillArr(count, i => getWalletSkinMock(i, type));

export const getWalletSkinsCollectionMock = (): WalletsSkinCollection => {
  return {
    card: getWalletSkinsByTypeMock(WalletType.Card),
    master: getWalletSkinsByTypeMock(WalletType.Master),
    crypto: getWalletSkinsByTypeMock(WalletType.Crypto),
  };
};

export function getWalletSkinIdMock(i: number, type: WalletType): number {
  const skinNumber = i % 3;
  switch (type) {
    case WalletType.Card: {
      return skinNumber;
    }
    case WalletType.Master: {
      return skinNumber + 3;
    }
    case WalletType.Crypto: {
      return skinNumber + 6;
    }
  }
}
